
import { Component } from "vue-property-decorator";
import Loader from "@/resources/mixins/loader/loader";
import { mixins } from "vue-class-component";
import { i18n } from "@/resources/locales";

@Component({})
export default class PermissionController extends mixins(Loader) {
    permissions = "prompt";
    video = false;
    audio = false;
    created(): void {
        this.permissions = "prompt";
    }
    destroyed(): void {
        this.removeTimeout();
    }
    checkBrowser(): string {
        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const isFirefox = /^((?!chrome|android).)*firefox/i.test(navigator.userAgent);

        if (isChrome) {
            return "chrome";
        }

        if (isSafari) {
            return "safari";
        }

        if (isFirefox) {
            return "firefox";
        }
        return 'default';
    }
    checkPermissions(callback) {
        switch (this.checkBrowser()) {
            case "chrome":
                this.permisionChrome(callback);
                break;
            case "safari":
                this.permisionSafari(callback);
                this.waitingResponse();
                break;
            case "firefox":
                this.permisionFirefox(callback);
                this.waitingResponse();
                break;

            default:
                break;
        }
    }
    permisionChrome(callback) {
        const camera = "camera" as PermissionName;
        navigator.permissions
            .query({
                name: camera,
            })
            .then(async (permissionStatus) => {
                this.permissions = permissionStatus.state;
                if (this.permissions === "granted") {
                    callback();
                }
                permissionStatus.addEventListener("change", async () => {
                    this.permissions = permissionStatus.state;
                    if (this.permissions === "granted") {
                        callback();
                    }
                });
            })
            .catch((e) => { });
        const microphone = "microphone" as PermissionName;
        navigator.permissions
            .query({
                name: microphone,
            })
            .then(async (permissionStatus) => {
                this.permissions = permissionStatus.state;
                if (this.permissions === "granted") {
                    callback();
                }
                permissionStatus.addEventListener("change", async () => {
                    this.permissions = permissionStatus.state;
                    if (this.permissions === "granted") {
                        callback();
                    }
                });
            })
            .catch((e) => {
                this.showError();
            });
    }
    permisionFirefox(callback) {
        this.startLoader(this.$store);
        navigator.mediaDevices
            .getUserMedia({ audio: true, video: false })
            .then((stream) => {
                if (this.permissions === "granted") {
                    this.audio = true;
                    if (this.video && this.audio) {
                        this.removeTimeout();
                        callback(stream);
                        this.stopLoader();
                    }
                    return;
                }
                this.permissions = "granted";
                this.permisionFirefox(callback);
            })
            .catch((err) => {
                this.removeTimeout();
                this.showError();
                this.permissions = "denied";
            });
        navigator.mediaDevices
            .getUserMedia({ audio: false, video: true })
            .then((stream) => {
                if (this.permissions === "granted") {
                    this.video = true;
                    if (this.video && this.audio) {
                        this.removeTimeout();
                        callback(stream);
                        this.stopLoader();
                    }
                    return;
                }
                this.permissions = "granted";
                this.permisionFirefox(callback);
            })
            .catch((err) => {
                this.removeTimeout();
                this.showError();
                this.permissions = "denied";
            });
    }
    permisionSafari(callback) {
        this.startLoader(this.$store);
        navigator.mediaDevices
            .getUserMedia({ audio: true, video: false })
            .then((stream) => {
                this.removeTimeout();
                if (this.permissions === "granted") {
                    this.audio = true;
                    if (this.video && this.audio) {
                        callback(stream);
                        this.stopLoader();
                    }
                    return;
                }
                this.permissions = "granted";
                this.permisionSafari(callback);
            })
            .catch((err) => {
                this.removeTimeout();
                this.showError();
                this.permissions = "denied";
            });

        navigator.mediaDevices
            .getUserMedia({ audio: false, video: true })
            .then((stream) => {
                this.removeTimeout();
                if (this.permissions === "granted") {
                    this.video = true;
                    if (this.video && this.audio) {
                        callback(stream);
                        this.stopLoader();
                    }
                    return;
                }
                this.permissions = "granted";
                this.permisionSafari(callback);
            })
            .catch((err) => {
                this.removeTimeout();
                this.showError();
                this.permissions = "denied";
            });
    }
    waitingResponse() {
        let waitingResponseTimeout = setTimeout(() => {
            this.showError();
        }, 120000);
        this.$store.dispatch(
            "SystemStore/setWaitingResponseTimeoutAction",
            waitingResponseTimeout
        );
    }
    showError() {
        this.stopLoader();
        this.onError(i18n.t("manageUsers.permissions.title"), i18n.t("notifications.descriptions.permissionError"), "none");
    }
    removeTimeout() {
        let waitingResponseTimeout = this.$store.getters["SystemStore/getWaitingResponseTimeout"];
        if (waitingResponseTimeout) {
            clearTimeout(waitingResponseTimeout);
        }
        this.$store.dispatch(
            "SystemStore/setWaitingResponseTimeoutAction",
            null
        );
    }
}